export default class SearchToggle {
  constructor(element) {
    this.searchToggler = element;
    this.searchDialog = document.querySelector('[data-search-dialog]');
    this.searchDialogClose = document.querySelector('[data-search-dialog-close]');
    this.searchDialogBackdrop = document.querySelector('[data-search-dialog-backdrop]');
    this.searchInput = document.getElementById('header-search');
    this.activeClass = 'is-active';
  }

  init() {
    this.searchToggler.addEventListener('click', () => {
      this.toggle();
    });
    this.searchDialogClose.addEventListener('click', () => {
      this.hide();
    });
    this.searchDialogBackdrop.addEventListener('click', () => {
      this.hide();
    });
    this.onKeyDown = this.onKeyDown.bind(this);
    return this;
  }

  onKeyDown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.searchDialogClose.click();
    }
  }

  toggle() {
    if (this.searchDialog.classList.contains(this.activeClass)) {
      this.hide();
    } else {
      this.show();
    }
  }

  show() {
    window.addEventListener('keydown', this.onKeyDown);
    document.documentElement.style.overflow = 'hidden';
    this.searchDialog.classList.add(this.activeClass);
    this.searchDialog.showModal();
    this.searchInput.focus();
  }

  hide() {
    window.removeEventListener('keydown', this.onKeyDown);
    document.documentElement.style.overflow = '';
    this.searchDialog.classList.remove(this.activeClass);
    this.searchDialog.close();
  }
}
